module.exports = __webpack_public_path__ + "static/media/screenshot2.42ac59be.jpg";